import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

class Footer extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { lang, trans } = this.props;
        const code = (lang != "" ? ("/" + lang) : "");
        return (
            <div className="simple-footer">
                <div className="container w-container">
                    <div className="footer-row w-row">
                        <div className="footer-logo-column-left w-col w-col-3">
                            <img src={"/static/images/footer-logo.png"} width="175" />
                        </div>
                        <div className="footer-menu-column w-col w-col-6">
                            <Link to={"/" + lang} className="footer-inline-link w--current">{trans('home')}</Link>
                            <Link to={code + "/usecases"} className="footer-inline-link w--current">{trans('Usecases')}</Link>
                            <Link to={code + "/pricing"} className="footer-inline-link">{trans('Pricing')}</Link>
                            <Link to={code + "/aboutus"} className="footer-inline-link">{trans('About us')}</Link>
                            <Link to={code + "/contact"} className="footer-inline-link">{trans('Contact')}</Link>
                        </div>
                        <div className="footer-social-col-right w-col w-col-3">
                            <a href="#" target="_blank" className="footer-social-icon w-inline-block">
                                <img src={"/static/images/5a14180debf0100001548b8c_community.png"} alt="HansaBot Community" className="footer-small-social-icon" />
                            </a>
                            <a href="#" target="_blank" className="footer-social-icon w-inline-block">
                                <img src={"/static/images/59fed69e519aa50001467677_Icon-twitter.png"} className="footer-small-social-icon" />
                            </a>
                            <a href="#" target="_blank" className="footer-social-icon w-inline-block">
                                <img src={"/static/images/59fed69e519aa5000146762b_Icon-facebook.png"} className="footer-small-social-icon" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="simple-bottom-footer">
                    <div className="container w-container">
                        <p className="bottom-footer-paragraph">
                            <strong data-new-link="true" className="bold-text">Copyright © 2018 HansaBot Ltd</strong>
                        </p>
                        <p className="bottom-footer-paragraph right">
                            <a href="#" className="bottom-footer-link">{trans('Terms of Service')}</a>
                            &nbsp;&nbsp;
                            <a href="#" className="bottom-footer-link">{trans('Privacy Policy')}</a>
                        </p>
                    </div>
                </div>
            </div>
        )
    }

}

export default connect(state => ({
    lang: state.app.lang
}))(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js